<template>
  <div>
    <div style="min-height: 200px;" v-if="isLoading">
      <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false"></b-loading>
    </div>
    <div  v-else>
      <div class="columns is-multiline">
        <div class="column" style="overflow-x: auto;">
          <bar-label-chart class="dynamic-chart" :style="{ 'min-width':  '100%','width': dynamicWidthChart }" v-if="!isLoading"
          :chart-data="defaultChart.chartData" :extra-options="defaultChart.extraOptions"
          ></bar-label-chart>
        </div>
      </div>
       <div class="notification">
            <div class="content">
              <b-field grouped group-multiline>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark" >Promedio</b-tag>
                    <b-tag type="is-light">{{this.avg}}</b-tag>
                  </b-taglist>
                </div>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark">Desviación Estandar</b-tag> <br>
                    <b-tag type="is-light">{{this.standardDeviation.toFixed(2)}}</b-tag>
                  </b-taglist>
                </div>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark">Varianza</b-tag>
                    <b-tag type="is-light">{{this.variance.toFixed(2)}}</b-tag>
                  </b-taglist>
                </div>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark">Nota Max.</b-tag>
                    <b-tag type="is-light">{{this.maxScore.toFixed(2)}}</b-tag>
                  </b-taglist>
                </div>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark">Nota Min.</b-tag>
                    <b-tag type="is-light">{{this.minScore.toFixed(2)}}</b-tag>
                  </b-taglist>
                </div>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark">Pendiente</b-tag>
                    <b-tag type="is-light">{{this.slope ? this.slope.toFixed(2) : 0}}</b-tag>
                  </b-taglist>
                </div>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark">Tiempo Transcurrido</b-tag>
                    <b-tag type="is-light">{{timeLapse}}</b-tag>
                  </b-taglist>
                </div>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark">Lecciones</b-tag>
                    <b-tag type="is-light">{{resultExercises.length}}</b-tag>
                  </b-taglist>
                </div>
              </b-field>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import * as chartConfig from '@/components/Charts/chart.config'
import BarLabelChart from '@/components/Charts/BarLabelChart'
import HorseService from '@/services/HorseService'

import colorsList from '@/utils/colorsList'

export default {
  components: {
    BarLabelChart
  },
  props: {
    selectedHorse: {
      type: Object,
      required: true
    },
    selectedExercise: {
      type: Array,
      required: true
    },
    barColor: {
      required: true
    },
    from: {
      required: false,
      default: null
    },
    to: {
      required: false,
      default: null
    }
  },
  created () {
    this.getHorsesResultExercise()
  },
  data () {
    return {
      defaultChart: {
        chartData: {},
        extraOptions: {
          ...chartConfig.chartOptionsMain,
          scales: {
            yAxes: [{
              ticks: {
                max: 10,
                min: 0,
                stepSize: 1
              }
            }],
            xAxes: [{
              ticks: {
                callback: function (value, index, values) {
                  return value
                }
              }
            }]
          },
          legend: {
            display: true
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ' : '
                }
                label += tooltipItem.yLabel
                return label
              },
              title: function (tooltipItem, data) {
                var label = tooltipItem[0].xLabel || ''
                return label
              }
            }
          }
        }
      },
      isLoading: false,
      colorsArr: colorsList,
      resultExercises: [],
      avg: 0,
      avgArr: [],
      variance: 0,
      standardDeviation: 0,
      negativeSD: [],
      positiveSD: [],
      tendency: [],
      maxScore: 0,
      minScore: 0,
      slope: 0
    }
  },
  methods: {
    async getHorsesResultExercise () {
      if (!this.selectedHorse || !this.selectedExercise[0]) {
        return false
      }
      this.isLoading = true
      let params = {
        from: this.from,
        to: this.to
      }
      let response = await HorseService.getResultHorseExercise(this.selectedHorse.id, this.selectedExercise[0], params)
      this.resultExercises = response.data
      this.initExerciseChartData()
      this.isLoading = false
    },
    initExerciseChartData () {
      this.mapData()

      this.defaultChart.chartData = {
        datasets: [
          {
            label: 'Promedio',
            data: this.avgArr,
            fill: false,
            borderWidth: 4,
            borderColor: 'rgba(244,67,54,0.6)',
            type: 'line',
            datalabels: {
              opacity: 0
            }
          },
          {
            label: 'Desviación Positiva',
            data: this.positiveSD,
            fill: false,
            borderWidth: 4,
            borderColor: 'rgba(3,169,244,0.6)',
            type: 'line',
            datalabels: {
              opacity: 0
            }
          },
          {
            label: 'Desviación negativa',
            data: this.negativeSD,
            fill: false,
            borderWidth: 4,
            borderColor: 'rgba(3,169,244,0.6)',
            type: 'line',
            datalabels: {
              opacity: 0
            }
          },
          {
            label: 'Tendencia',
            data: this.tendency,
            fill: false,
            borderWidth: 4,
            borderColor: 'rgba(156,39,176,0.6)',
            type: 'line',
            datalabels: {
              opacity: 0
            }
          },
          {
            maxBarThickness: 20,
            backgroundColor: this.barColor,
            data: this.scores,
            label: `${this.selectedHorse.name} - ${this.selectedExercise[1]}`,
            datalabels: {
              display: true,
              align: 'top',
              offset: 5,
              anchor: 'end',
              borderRadius: 3,
              color: 'black',
              rotation: 75,
              font: {
                size: 12
              }
            }
          }
        ],
        labels: this.labels
      }
    },
    mapData () {
      this.avgArr = []
      this.negativeSD = []
      this.positiveSD = []
      this.scores = []
      this.labels = []
      this.tendency = []
      this.avg = 0
      this.maxScore = 0
      this.minScore = 0
      let totalScore = 0
      let totalX = 0
      let totalXY = 0
      let totalPowX = 0
      let numberScores = this.resultExercises.length

      for (let index = 0; index < this.resultExercises.length; index++) {
        let executionResult = this.resultExercises[index]
        let score = parseFloat(executionResult.base_score)
        let x = index + 1
        totalScore += score
        totalX += x
        let xy = x * score
        totalXY += xy
        let powX = Math.pow(x, 2)
        totalPowX += powX

        if (this.maxScore === 0 && this.minScore === 0) {
          this.maxScore = score
          this.minScore = score
        }
        if (score > this.maxScore) {
          this.maxScore = score
        }
        if (score < this.minScore) {
          this.minScore = score
        }
        this.scores[index] = score.toFixed(2)
      }

      this.avg = (totalScore / numberScores).toFixed(2)

      this.slope = ((numberScores * totalXY) - totalX * totalScore) / ((numberScores * totalPowX) - Math.pow(totalX, 2))
      let b = (totalScore / numberScores) - (this.slope * (totalX / numberScores))

      let summation = 0

      for (let index = 0; index < numberScores; index++) {
        let executionResult = this.resultExercises[index]
        summation += Math.pow((executionResult.base_score - this.avg), 2)
      }

      this.variance = Number.parseFloat(summation) / numberScores
      this.standardDeviation = Math.sqrt(this.variance)

      for (let index = 0; index < numberScores; index++) {
        let executionResult = this.resultExercises[index]
        let judges = `Jueces: ${executionResult.judges}`
        let date = this.$moment(executionResult.date, 'YYYY-MM-DD').format('DD-MM-YYYY')
        this.labels[index] = [
          judges,
          date
        ]
        let x = index + 1
        this.tendency[index] = ((this.slope * x) + b).toFixed(2)
        this.negativeSD[index] = (this.avg - this.standardDeviation).toFixed(2)
        this.positiveSD[index] = (Number.parseFloat(this.avg) + Number.parseFloat(this.standardDeviation)).toFixed(2)
        this.avgArr[index] = this.avg
      }
    }
  },
  computed: {
    dynamicWidthChart () {
      return `${this.resultExercises.length * 400}px`
    },
    timeLapse () {
      let diff = 0
      if (this.resultExercises.length === 1) {
        let firstDate = this.$moment(this.resultExercises[0].date, 'YYYY-MM-DD')
        let lastDate = this.$moment(this.resultExercises[0].date, 'YYYY-MM-DD')
        diff = firstDate.diff(lastDate)
      } else if (this.resultExercises.length > 1) {
        let firstDate = this.$moment(this.resultExercises[0].date, 'YYYY-MM-DD')
        let lastDate = this.$moment(this.resultExercises[this.resultExercises.length - 1].date, 'YYYY-MM-DD')
        diff = firstDate.diff(lastDate)
      }
      return diff !== 0 ? this.$moment.duration(diff).humanize() : 'Faltan más datos'
    }
  },
  watch: {
    selectedHorse () {
      this.getHorsesResultExercise()
    },
    selectedExercise () {
      this.getHorsesResultExercise()
    }
  }
}
</script>

<style scoped>
  .dynamic-chart{
    height: 300px !important;
    min-height: 250px !important;
  }

  .tags-container{
    padding-top: 3rem;
  }
</style>
